import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";

import css from "../assets/css.png";
import figma from "../assets/figma.png";
import flutter from "../assets/flutter.png";
import git from "../assets/git.png";
import graphql from "../assets/graphql.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import mu5 from "../assets/mu5.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";

import vue from "../assets/vue.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

import profile from "../assets/profile.png";
import profile1 from "../assets/profile1.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";


import bolt from "../assets/bolt.png";


import jvl from "../assets/JVL.jpg";
import tamilHacks from "../assets/Tamil Hacks.jpg";
import balachandar from "../assets/Bala.jpg";
import tutorJoe from "../assets/Tutor Joes.jpg";
import Akshay from "../assets/AS.jpg";
import RSC from "../assets/RSC.jpg";
import CE from "../assets/CE.jpg";
import GS from "../assets/GS.jpg";
import TM from "../assets/TM.jpg";
import DBY from "../assets/dby.jpg";
import WDS from "../assets/WDS.jpg";
import NN from "../assets/Net Ninja.jpg";
import DM from "../assets/Dipesh Malvia.jpg";
import CS from "../assets/CS in Tamil.jpg";

import bootstrap from "../assets/bootstrap.png";
import express from "../assets/express.png";
import mongoDB from "../assets/mongodb.png";

export default {
  CS,
  DM,
  NN,
  WDS,
  DBY,
  TM,
  GS,
  CE,
  RSC,
  Akshay,
  tutorJoe,
  balachandar,
  tamilHacks,
  jvl,
  email,
  mobile,
  api,

  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,

  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  profile1,
  circle,
  logo,
  bolt,
  

  bootstrap,
  express,
  mongoDB,
};
